/**
 * MED-1365: the confirmation words of a booking. The public booking page and
 * the participant portal use these, so both say the same thing.
 */

/** Where the booking was made. */
export type BookingSurface = 'public' | 'portal';

/**
 * The start of the "invite is on its way" line. A Calendly fallback booking
 * is a Google Calendar invite from the Medley calendar, so the line names
 * that calendar.
 */
export function inviteLeadText(fallback: boolean): string {
  return fallback
    ? 'A calendar invite from the Medley calendar is on its way to '
    : 'A calendar invite is on its way to ';
}

/**
 * The address that a logged-out participant writes to about a booking, when
 * the API does not give the cohort's (contact_email, MED-1365 QA round 6).
 */
export const MEDLEY_TEAM_EMAIL = 'team@withmedley.com';

/**
 * How to change or cancel the booking. A portal user changes it on the
 * dashboard. On the public page, a fallback booking has no Calendly link and
 * the page shows no coach address, so the person writes to the Medley team.
 */
export function changeOrCancelText(
  fallback: boolean,
  surface: BookingSurface,
  /** QA round 6: the cohort's address, the same as in the invite. */
  contactEmail: string = MEDLEY_TEAM_EMAIL
): string {
  if (surface === 'portal') {
    return 'To change or cancel, use Reschedule or Cancel on your dashboard.';
  }
  return fallback
    ? `To change or cancel, email the Medley team at ${contactEmail}.`
    : 'To change or cancel, use the link in your calendar invite.';
}
